export default __webpack_public_path__ + "static/data-ef8984f5f1f929812ae5aeabcc98cedb.png";